<template>
  <div class="picto-component">
    <Info v-if="needInfo()" :title="info.title" :text="info.infoKey" ></Info>
    <div class="circle picto-svg" :style="'border: 1px solid'+ color ">
      <div :class="name"></div>
    </div>
    <div class="picto-text">
      <div class="picto-number" :style="'color:'+ color ">
        {{this.number}}
      </div>
      <div class="picto-legend">
        {{this.legend}}
      </div>
      <div class="picto-legend" :style="'color:'+ color " v-if="currency">
        {{this.currency}}
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Picto',
    components: {
      Info
    },
    props: {
      color: String,
      text: String,
      name: String,
      number: String,
      legend: String,
      currency: String
    },
    data() {
      return {
        info: {
         title: "",
         infoKey: ""
        },
      }
    },
    mounted() {
    },
    methods: {
      needInfo() {
        if(this.legend === 'pictoContainer.frequencyPerYearLegend') {
          this.info.title = "pictoContainer.frequenceTitle";
          this.info.infoKey = "pictoContainer.frequenceInfo";
          return true;
        }else if(this.legend === 'pictoContainer.averageCartLegend') {
          this.info.title = "pictoContainer.averageCartTitle";
          this.info.infoKey = "pictoContainer.basketInfo";
          return true;
        }
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/picto.sass"
</style>
